import { Button, Checkbox, Modal } from "antd";
import React, { useEffect, useState } from "react";

const DeleteSubDomainModal = ({ open, setOpen, selectedBusiness, onSubmit }) => {
    const [loading, setLoading] = useState(false);
    const [selectedSubdomains, setSelectedSubdomains] = useState([]);
    const [availableSubdomains, setAvailableSubdomains] = useState([]);

    useEffect(() => {
        if (open && selectedBusiness) {
            const domains = (selectedBusiness.domain || "")
                .split(",")
                .map(d => d.trim())
                .filter(d => d.endsWith(".bimeh.com"));

            setAvailableSubdomains(domains);
            setSelectedSubdomains([]);
        }
    }, [open, selectedBusiness]);

    const handleCheckboxChange = (subdomain, checked) => {
        setSelectedSubdomains(prev =>
            checked ? [...prev, subdomain] : prev.filter(s => s !== subdomain)
        );
    };

    const handleSubmit = async () => {
        if (selectedSubdomains.length === 0) return;
        setLoading(true);
        try {
            const prefixes = selectedSubdomains.map(d => d.replace(".bimeh.com", ""));
            await onSubmit(prefixes);
            handleClose();
        } catch (error) {
            console.error("Error deleting subdomains:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedSubdomains([]);
        setAvailableSubdomains([]);
    };

    return (
        <Modal
            title="حذف ساب‌دامین‌(ها)"
            open={open}
            onCancel={handleClose}
            footer={[
                <Button key="cancel" onClick={handleClose} disabled={loading}>
                    انصراف
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    danger
                    disabled={selectedSubdomains.length === 0 || loading}
                    onClick={handleSubmit}
                    loading={loading}
                >
                    حذف ({selectedSubdomains.length})
                </Button>
            ]}
        >
            {availableSubdomains.length === 0 ? (
                <div style={{ textAlign: "center", padding: "20px 0", color: "#999" }}>
                    هیچ ساب‌دامین bimeh.com یافت نشد
                </div>
            ) : (
                <>
                    <div style={{ marginBottom: 16, color: "#666" }}>
                        ساب‌دامین‌های موجود در بیزنس <strong>{selectedBusiness?.name}</strong>:
                    </div>
                    <div style={{ maxHeight: 300, overflowY: "auto" }}>
                        {availableSubdomains.map((subdomain) => (
                            <div
                                key={subdomain}
                                style={{ padding: "8px 12px", borderBottom: "1px solid #f0f0f0" }}
                            >
                                <Checkbox
                                    checked={selectedSubdomains.includes(subdomain)}
                                    onChange={(e) => handleCheckboxChange(subdomain, e.target.checked)}
                                >
                                    {subdomain}
                                </Checkbox>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </Modal>
    );
};

export default DeleteSubDomainModal;
